import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClassificationReporterService } from 'src/app/views/apps/news-analyzer/classification-reporter.service';
import { TOPICS } from 'src/app/views/apps/news-analyzer/utils';

export interface DialogData {
    text: string;
    topic: string,
    token: string
}

@Component({
    selector: 'app-dialog-rectify-topic',
    templateUrl: 'dialog-rectify-topic.html',
})
export class DialogRectifyTopicComponent implements OnInit {
    listOfTopics: { name }[]
    selectedTopic: any

    constructor(
        public dialogRef: MatDialogRef<DialogRectifyTopicComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private classificationReporterService: ClassificationReporterService) { }

    ngOnInit() {
        this.listOfTopics = TOPICS.filter(t => t !== this.data.topic)
            .map(topic => ({ name: topic }));
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onRectifyClick(): void {
        console.log(this.selectedTopic)
        this.classificationReporterService.reportWrongClassification(
            this.data.text, this.data.topic, this.selectedTopic, 'topic', this.data.token)
        this.dialogRef.close();
    }
}
